import { LayoutCustomization } from '@data';

import { CustomModule } from '../CustomModule/CustomModule';
import { Graph } from '../Graph';
import { ModuleReorderItem } from '../ModuleReorder/ModuleReorder';
import { TablePanel } from '../TablePanel';

const GRAPH_IDENTIFIER = 'graph.';
const TABLE_IDENTIFIER = 'module.table';

type ModuleRendererProps = {
    modules?: LayoutCustomization[];
    isEditing?: boolean;
    handleRemove: (id: string) => void;
    setAddItemIndex: (id: number) => void;
};

export const ModuleRenderer = ({ modules, isEditing, handleRemove, setAddItemIndex }: ModuleRendererProps) => {
    return modules?.map((module, index) => (
        <ModuleReorderItem
            value={module.childUiNodeId}
            key={module.id}
            isEditing={isEditing}
            onRemove={() => handleRemove(module.childUiNodeId)}
            onAdd={() => setAddItemIndex(index)}
        >
            <ModuleItem uiNodeId={module.childUiNodeId} isEditing={isEditing} />
        </ModuleReorderItem>
    ));
};

type ModuleItemProp = {
    uiNodeId: string;
    isEditing?: boolean;
};

const ModuleItem = ({ uiNodeId, isEditing }: ModuleItemProp) => {
    if (uiNodeId.startsWith(GRAPH_IDENTIFIER)) {
        return <Graph nodeId={uiNodeId} isEditing={isEditing} />;
    }
    return uiNodeId === TABLE_IDENTIFIER ? (
        <TablePanel nodeId={uiNodeId} isEditing={isEditing} />
    ) : (
        <CustomModule nodeId={uiNodeId} isEditing={isEditing} />
    );
};
